import { render, staticRenderFns } from "./ModuleGrid.vue?vue&type=template&id=457364e6&scoped=true&"
import script from "./ModuleGrid.vue?vue&type=script&lang=js&"
export * from "./ModuleGrid.vue?vue&type=script&lang=js&"
import style0 from "./ModuleGrid.vue?vue&type=style&index=0&id=457364e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457364e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCard,VCardText,VContainer,VDialog,VImg,VMain,VRow,VSnackbar})
